let select, manufacturerSelect, manufacturerField, models, modelSelect, modelField, wheelbaseSelect, wheelbaseField;

function fetchModels(manufacturer) {
    let modelList = [];

    // Wipe existing models
    resetModels();

    // Fetch models based on vendor search
    $.getJSON('/search/suggest.json', {
        'q': manufacturer,
        'resources': {
            'type': 'product',
            'options': {
                'unavailable_products': 'hide',
                'fields': 'vendor'
            }
        }
    }).done(function(response) {
        const products = response.resources.results.products;

        // Update models to include products
        models = products;

        if( products.length > 0 ) {
            for( let i = 0; i < products.length; i++ ) {
                const thisModel = products[i].type;
                const thisOption = new Option(thisModel, 'product_type:"' + thisModel + '"', false, false);

                // Check model has type + is unique to other models.
                // Add to select
                if( thisModel && modelList.indexOf(thisModel) === -1 ) {
                    modelSelect.append(thisOption).trigger('change');
                    modelList.push(thisModel);
                }
            }
        }
    });
}

function fetchWheelbase(model) {
    if (!model || !models) {
        return;
    }

    resetWheelbases();

    // Get name of model
    const modelName = model.split(':')[1].replaceAll('"', '');
    
    // Filter array to selected model
    model = models.filter(model => model.type == modelName)[0];

    // Filter tags to only wheelbases
    const validTags = ['wheel-s', 'wheel-m', 'wheel-l', 'wheel-xl'];
    const tags = model.tags;
    const wheelbases = tags.filter(tag => validTags.includes(tag)).sort();

    // Sort based on validTags array
    wheelbases.sort(function(a, b){  
        return validTags.indexOf(a) - validTags.indexOf(b);
    });

    if (wheelbases.length > 0) {
        for (let i = 0; i < wheelbases.length; i++) {
            let optionLabel = '';

            switch (wheelbases[i]) {
                case 'wheel-s':
                    optionLabel = 'Short';
                    break;
                case 'wheel-m':
                    optionLabel = 'Medium';
                    break;
                case 'wheel-l':
                    optionLabel = 'Long';
                    break;
                case 'wheel-xl':
                    optionLabel = 'Extra Long';
                    break;
            }

            if (!optionLabel) {
                return;
            }

            // Add option to select
            const thisOption = new Option(optionLabel, 'tag:"' + wheelbases[i] + '"', false, false);
            wheelbaseSelect.append(thisOption).trigger('change');
        }
    }

}

function resetModels() {
    const modelOptions = modelSelect.find('option[value=""]').siblings();

    // Remove options
    modelOptions.remove();
}

function resetWheelbases() {
    const wheelbaseOptions = wheelbaseSelect.find('option[value=""]').siblings();

    // Remove options
    wheelbaseOptions.remove();
}

function concatQuery() {
    const advancedQuery = $('.advanced-search-query');
    let query = '';

    // Concat query string
    select.each(function() {
        const thisValue = $(this).val();

        if( thisValue ) {
            if( !query ) {
                query += thisValue;
            } else {
                query += ':' + thisValue;
            }
        }
    });

    // Update value for query
    advancedQuery.val(query);
}

function hintField(field) {
    field.addClass('hint-wiggle');

    setTimeout(function() {
        field.removeClass('hint-wiggle');
    }, 1500);
}

function advancedSearch() {
    const form = $('.advanced-search');

    // Set globals
    manufacturerSelect = $('select.advanced-manufacturer');
    manufacturerField = manufacturerSelect.parent();
    modelSelect = $('select.advanced-model');
    modelField = modelSelect.parent();
    wheelbaseSelect = $('select.advanced-wheelbase');
    wheelbaseField = wheelbaseSelect.parent();
    select = form.find('select');

    // Listen for manufacturer change
    manufacturerSelect.on('change', function() {
        const manufacturer = $(this).val();

        if( manufacturer ) {
            fetchModels(manufacturer);
        } else {
            resetModels();
        }
    });

    // Listen for model click
    modelField.on('click', function() {
        if( modelSelect.first().find('option').length === 1 ) {
            hintField(manufacturerField);
        }
    });

    // Listen for wheelbase click
    wheelbaseField.on('click', function() {
        if( wheelbaseSelect.first().find('option').length === 1 ) {
            hintField(modelField);
        }
    });

    // Fetch wheelbase options when model is selected
    modelSelect.on('change', function() {
        fetchWheelbase($(this).val());
    });

    // Create URL params each time select is changed
    select.on('change', concatQuery);
}

$(document).ready(function() {
    advancedSearch();
});